// 成績紀錄以科目 ID 關聯；顯示時用 ID 查目前的科目名稱。

type SubjectRef = { id: string; n: string };

// 不對應實際科目的虛擬科目
export const ALL_SUB_ID = 'all';        // 隨機混合（所有科目）
export const WRONGS_SUB_ID = 'wrongs';  // 錯題複習
const PSEUDO: SubjectRef[] = [
  { id: ALL_SUB_ID, n: '綜合' },
  { id: WRONGS_SUB_ID, n: '錯題複習' },
];

/** 回傳「科目 ID → 目前名稱」查詢函式；查不到時用紀錄當下保存的名稱，再退回 ID */
export function makeSubjectNameOf(subjects: SubjectRef[]) {
  const byId = new Map([...PSEUDO, ...subjects].map(s => [s.id, s.n]));
  return (id: string | undefined | null, fallback?: string): string =>
    byId.get(id ?? '') ?? fallback ?? id ?? '';
}
